import { t } from '@lingui/core/macro';
import { PROVIDER_IDS, DocuSignIcon } from 'app/domains/esigning/utils';
import { MiramisLogotype } from 'shared/domains/common-ui';
export const getProviderData = (provider) => {
    const data = {
        [PROVIDER_IDS.DOCUSIGN]: {
            logo: DocuSignIcon,
            name: t({ message: 'DocuSign', comment: 'DocuSign provider name' }),
            description: t({
                message: 'Subscription service',
                comment: 'This is the description for the DocuSign provider',
            }),
            ariaLabelConnected: t({
                message: 'Choose DocuSign',
                comment: 'Used for aria label (screen reader) for the DocuSign provider',
            }),
            ariaLabelUnconnected: t({
                message: 'Connect to DocuSign',
                comment: 'Used for aria label (screen reader) for the DocuSign provider',
            }),
        },
        [PROVIDER_IDS.IDURA]: {
            logo: MiramisLogotype,
            name: t({ message: 'Miramis', comment: 'Miramis provider name' }),
            description: t({
                message: 'Native eSigning - fully integrated',
                comment: 'This is the description for our own (Miramis) provider',
            }),
            ariaLabelConnected: t({
                message: 'Choose Miramis',
                comment: 'Used for aria label (screen reader) for our own provider',
            }),
            ariaLabelUnconnected: t({
                message: 'Connect to Miramis',
                comment: 'Used for aria label (screen reader) for our own provider',
            }),
        },
    };
    return data[provider];
};
